import React from 'react';

import { useFormStyle } from '@hooks/style/useFormStyle';
import { CustomText } from '@components/textFields/CustomText';

type SubtitleProps = {
  testID: string;
  text: string;
};

export const Subtitle = ({ testID, text }: SubtitleProps): JSX.Element => {
  const { subtitle } = useFormStyle();

  return <CustomText testID={`${testID}_subtitle`} as={'h2'} text={text} typeStyle={subtitle} />;
};
